import { FamilyUnit, InsuredPeopleDto } from '@zorro/clients';
import { calculateFamilyUnit } from '@zorro/types';

export const getDefaultWhoIsEnrolled = (
  insured: InsuredPeopleDto,
  familyUnit: FamilyUnit = calculateFamilyUnit(insured)
): string[] => {
  const { employee, spouse, dependents } = insured;

  const employeeId = employee.id;
  const spouseId = spouse?.id;
  const dependentsIds = dependents.map(({ id }) => id);

  switch (familyUnit) {
    case FamilyUnit.EMPLOYEE_ONLY: {
      return [employeeId];
    }
    case FamilyUnit.EMPLOYEE_SPOUSE: {
      return [employeeId, spouseId].filter((id) => id !== undefined);
    }
    case FamilyUnit.EMPLOYEE_CHILD: {
      return [employeeId, ...dependentsIds];
    }
    case FamilyUnit.FAMILY: {
      return [employeeId, spouseId, ...dependentsIds].filter(
        (id) => id !== undefined
      );
    }
    default: {
      return [employeeId];
    }
  }
};
